export const ChartType = {
  LINE: 'line',
  BAR: 'bar',
  PIE: 'pie',
  DOUGHNUT: 'donut',
  RADAR: 'radar',
  POLAR: 'polar',
};

export const WIDTH_SIZES = {
  xl: '145px',
  lg: '79px',
  md: '70px',
  sm: '65px',
  xs: '59px',
  xxs: '45px',
  micro: '40px',
  tiny: '38px',
  mini: '37px',
  nano: '33px',
};
